import ChangePasswordForm from "./ChangePasswordForm";
import CreateSalonAppointmentForm from "./CreateSalonAppointmentForm";
import CreateUserCustomerIdForm from "./CreateUserCustomerIdForm";
import CreateWorkingHourForm from "./CreateWorkingHourForm";
import EditSalonAppointmentForm from "./EditSalonAppointmentForm";
import EditWorkingHourForm from "./EditWorkingHourForm";
import LoginForm from "./LoginForm";
import RecoverPasswordForm from "./RecoverPasswordForm";
import RegisterEmployeeForm from "./RegisterEmployeeForm";
import RegisterForm from "./RegisterForm";
import RegisterSalonServiceForm from "./RegisterSalonServiceForm";
import RequestCodeForm from "./RequestCodeForm";
import CreateUserBankAccountForm from "./CreateUserBankAccountForm";
import CreateSalonForm from "./CreateSalon";
import CreateObservationForm from "./CreateObservationForm";
import CreateAiIntegrationForm from "./CreateAiIntegrationForm";
import UpdateAiIntegrationForm from "./UpdateAiIntegrationForm";
import CreateAiConfigurationForm from "@/components/shared/Forms/CreateAiConfigurationForm";
import UpdateAiConfigurationForm from "@/components/shared/Forms/UpdateAiConfigurationForm";
import UpdateToolForm from "@/components/shared/Forms/UpdateToolForm";
import CreateToolForm from "@/components/shared/Forms/CreateToolForm";
import EditorEmployeeForm from "@/components/shared/Forms/EditorEmployeeForm";
import UpdateServiceForm from "@/components/shared/Forms/UpdateServiceForm";

const Forms = {
  LoginForm,
  RegisterForm,
  RequestCodeForm,
  RecoverPasswordForm,
  ChangePasswordForm,
  CreateSalonAppointmentForm,
  EditSalonAppointmentForm,
  EditWorkingHourForm,
  CreateWorkingHourForm,
  RegisterSalonServiceForm,
  RegisterEmployeeForm,
  CreateUserCustomerIdForm,
  CreateUserBankAccountForm,
  CreateSalonForm,
  CreateObservationForm,
  CreateAiIntegrationForm,
  UpdateAiIntegrationForm,
  CreateAiConfigurationForm,
  UpdateAiConfigurationForm,
  UpdateToolForm,
  CreateToolForm,
  EditorEmployeeForm,
  UpdateServiceForm,
};

export default Forms;
